import { styled } from "@mui/system";
import { colors } from "../config/colors";
import { Modal } from "react-bootstrap";
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_MD,
  FONT_SIZE_XXL,
  BORDER_RADIUS_LG,
  FONT_SIZE_CUSTOM_LG,
} from "../config/styles";

export const ConfirmationModalStyled = styled(Modal)(({ theme }) => ({
  "& .modal-dialog": {
    maxWidth: "408px",
    margin: "1.75rem auto",
  },
  "& .modal-content": {
    borderRadius: BORDER_RADIUS_LG,
    border: "none",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    padding: 0,
    backgroundColor: colors.surface,
  },
  "& .modal-body": {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  "& .icon-container": {
    display: "flex",
    padding: "36px 10px 0 10px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
  },
  "& .info-icon": {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    backgroundColor: colors.primary,
    color: colors.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "32px",
    fontWeight: FONT_WEIGHT_BOLD,
  },
  "& .text-container": {
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    alignSelf: "stretch",
  },
  "& .modal-title": {
    fontSize: FONT_SIZE_XXL,
    fontFamily: "DM Sans",
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: "28px",
    letterSpacing: "-0.8px",
    color: colors.custom,
    textAlign: "center",
    alignSelf: "stretch",
    margin: 0,
  },
  "& .modal-message": {
    fontSize: FONT_SIZE_MD,
    fontFamily: "DM Sans",
    fontWeight: FONT_WEIGHT_NORMAL,
    lineHeight: FONT_SIZE_CUSTOM_LG,
    color: colors.grayLight,
    textAlign: "center",
    alignSelf: "stretch",
    margin: 0,
  },
  "& .actions-container": {
    display: "flex",
    padding: "0 24px 24px 24px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    backgroundColor: colors.surface,
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
}));
